export function formatString(
  template: string,
  values: Record<string, any>
): string {
  return template.replace(/\{{(.*?)}}/g, (_, key) => {
    if (typeof values[key] === "object" || values[key] === null)
      throw new Error(`${key} value cannot be templated`);

    return values[key] !== undefined ? values[key] : "";
  });
}

export function resolveImageSource(imageObj: any): any {
  return imageObj.src;
}
